<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Vorhersage</h3>
    <span class="bericht-text-sub-label">Heute & Kommende Nacht</span>
    {{cosmoBericht?.vorhersageHeuteUndNacht}}

  </div>
<div class="bericht-text-container">
  <h3>Aussichten</h3>
    <span class="bericht-text-sub-label">{{cosmoBericht?.aussichten?.datum | date: 'EEE MM.dd'}}</span>
    {{cosmoBericht?.aussichten?.text}}
</div>

</div>
